import React, {useEffect, useRef, useContext} from "react";
import { useTranslation } from "react-i18next";

import Typography from "/src/touchpoints/rise/components/Typography";

import { random } from "/src/touchpoints/rise/utils/math";

import { GLYPHS } from "/src/touchpoints/rise/constants/codification";

import Context from "./Codification.context";
import defaultProps from "./Codification.defaultProps";
import propTypes from "./Codification.propTypes";

const CodificationCharacter = ({ text, index, className = '' }) => {
	const { typography, active, dir, repeat, timeout, trigger, onTrigger, reverse, isStatic, initialIsStatic } =
		useContext(Context);
	const { t } = useTranslation();
	const glyphRef = useRef();
	const resultRef = useRef();
	const isActive = active === index;
	let step = reverse ? repeat : 0;
	const updateTimeout = useRef(null);

	const getRandomGlyph = () => t(`glyphs.${GLYPHS[random(0, GLYPHS.length - 1)]}`);

	const setGlyph = (value) => {
		if (glyphRef.current) {
			glyphRef.current.innerText = value;
		}
	};

	const clearUpdateTimeout = () => {
		clearTimeout(updateTimeout.current);
		updateTimeout.current = null;
	};

	const onRepeat = () => {
		clearUpdateTimeout();

		step += dir;
		setGlyph(getRandomGlyph());

		if (step === trigger) {
			onTrigger();
		}
	};

	const onComplete = () => {
		setGlyph(reverse ? "" : text);
		clearUpdateTimeout();
	};

	const setUpdateTimeout = () => {
		updateTimeout.current = setTimeout(() => {
			if (step >= 0 && step <= repeat) {
				onRepeat();
				setUpdateTimeout();
			} else {
				onComplete();
			}
		}, timeout);
	};

	useEffect(() => {
		if (!isStatic && isActive) {
			if ((reverse && step === repeat) || (!reverse && step === 0)) {
				setUpdateTimeout();
			}
		}

		return () => {
			if (!isActive) {
				clearUpdateTimeout();
			}
		};
	}, [isActive]);

	useEffect(() => {
		if (initialIsStatic && !isStatic && !reverse) {
			setGlyph("");
		}
	}, [isStatic]);

	useEffect(() => {
		if (reverse) {
			setGlyph(text);
		}

		if (initialIsStatic) {
			setGlyph(text);
		}

		return () => {
			clearUpdateTimeout();
		};
	}, []);

	return (
		<Typography className={`c-codification__character ${className}`} {...typography} tag="span">
			<span ref={resultRef} className="c-codification__result">
				{text}
			</span>

			<span ref={glyphRef} className="c-codification__glyph" />
		</Typography>
	);
};

CodificationCharacter.defaultProps = defaultProps.character;
CodificationCharacter.propTypes = propTypes.character;

export default CodificationCharacter;
